import iframeResize from 'iframe-resizer/js/iframeResizer';

// Job offer detail page. Extracted from an inline <script> in the Twig template (ORT-3134).

function initApplicationForm() {
  const formToggleButtons = document.querySelectorAll('button.joboffers-form-toggle');
  if (!formToggleButtons.length) {
    return;
  }

  const frame = document.getElementById('joboffer-form-frame');

  // Two elements can show a scrollbar inside the frame: P&I's document (html { overflow-y:
  // auto }) and its own .LG-ScrollPanel, which is sized to the viewport. iframe-resizer v4
  // truncates the height the frame reports (parseInt in iframeResizer.js), so a measured
  // 1588.69px sizes the frame to 1588px - and the panel then holds 1589px of content and draws
  // a 6px scrollbar. Suppress it rather than correcting the height: every hover inside the frame
  // emits several resize messages, so adding a pixel per message compounds, which grew the frame
  // from 1589px to 1634px over eight hovers before this was caught. Only the one truncated pixel
  // is hidden, so nothing reachable is clipped. Injecting a stylesheet works because the proxy
  // makes the frame same-origin.
  const SCROLLBAR_FIX_ID = 'joboffer-frame-scrollbar-fix';
  const suppressFrameScrollbars = () => {
    try {
      const doc = frame.contentDocument;
      if (!doc || doc.getElementById(SCROLLBAR_FIX_ID)) {
        return;
      }
      const style = doc.createElement('style');
      style.id = SCROLLBAR_FIX_ID;
      style.textContent = 'html, .LG-ScrollPanel { overflow-y: hidden !important; }';
      (doc.head || doc.documentElement).appendChild(style);
    } catch (e) {
      // Cross-origin, i.e. app.ats_form_host is empty and the frame points straight at P&I.
      // Nothing to do; the frame keeps its own scrollbar.
    }
  };

  // The form lives at P&I but is served through our own /bewerber-web/ reverse proxy, so its
  // session cookie is first-party. Load it on first open only: re-assigning src on every click
  // (as the old inline script did, including when closing) reloaded the frame and threw away
  // whatever the applicant had already typed.
  const showFrame = () => {
    if (!frame) {
      return;
    }

    if (!frame.dataset.loaded && frame.dataset.src) {
      frame.src = frame.dataset.src;
      frame.dataset.loaded = '1';

      // P&I ships iframeResizer.contentWindow.js and calls parentIFrame.autoResize(); this is the
      // matching host side. Without it the frame keeps a hard-coded height that neither matches
      // the form nor its error state. lowestElement rather than the bodyOffset default: the GWT
      // app positions absolutely, so its body reports the viewport height instead of the content.
      iframeResize({
        log: false,
        heightCalculationMethod: 'lowestElement',
        // Runs after every measurement the frame reports, which is the only reliable moment:
        // the GWT app boots long after the load event and navigates internally, and either can
        // drop an inline style set earlier. Setting a CSS property is idempotent, so unlike the
        // earlier attempt at correcting the height here, this cannot compound.
        onResized: suppressFrameScrollbars,
      }, frame);
      // Also on load, so the frame is clean before the first measurement arrives.
      frame.addEventListener('load', suppressFrameScrollbars);
      return;
    }

    // Re-measure on every reopen. A hidden element has no layout, so a measurement that lands
    // while the form is closed reports a few pixels and leaves the frame collapsed once it is
    // shown again. Observed on staging: the frame came back at 24px instead of ~1590px.
    frame.iFrameResizer?.resize();
  };

  formToggleButtons.forEach(formToggleButton => {
    formToggleButton.addEventListener('click', (e) => {
      const handleMethod = e.currentTarget.dataset.method;
      const jobOfferForm = document.getElementById('joboffer-form');
      const jobOfferContent = document.getElementById('joboffer-content');

      jobOfferContent.hidden = handleMethod == 'toggle' ? !jobOfferContent.hidden : true;
      jobOfferForm.hidden = handleMethod == 'toggle' ? !jobOfferForm.hidden : false;

      formToggleButtons.forEach(button => {
        button.setAttribute('aria-expanded', jobOfferContent.hidden);
      });

      const formIsOpen = jobOfferForm.hidden == false;
      if (formIsOpen) {
        showFrame();
      }

      document.getElementById(formIsOpen ? 'joboffer-form' : 'joboffer-top').scrollIntoView({ behavior: 'smooth' });
      document.getElementById(formIsOpen ? 'joboffer-form-frame' : 'joboffer-top').focus();
    });
  });
}

function initBenefitsScrollbar() {
  document.querySelectorAll('.joboffers-benefits').forEach((wrapper) => {
    const holder = wrapper.querySelector('.joboffers-benefits-holder');
    const scrollIndicator = wrapper.querySelector('.joboffers-benefits-scroll-indicator');
    if (!holder || !scrollIndicator) {
      return;
    }

    const update = () => {
      const outerWidth = holder.offsetWidth;
      const innerWidth = holder.scrollWidth;
      scrollIndicator.style.setProperty('--outerWidth', outerWidth);
      scrollIndicator.style.setProperty('--innerWidth', innerWidth);
      scrollIndicator.style.setProperty('--amountScrolled', holder.scrollLeft);
      scrollIndicator.classList.toggle('opacity-0', innerWidth <= outerWidth);
    };

    holder.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });
}

initApplicationForm();
initBenefitsScrollbar();
